// extracted by mini-css-extract-plugin
export default {"mcWrapper":"CourseCards_mcWrapper__NnN9H","details":"CourseCards_details__PpZU+","forceColumn":"CourseCards_forceColumn__tjRs+","grid":"CourseCards_grid__8wnyv"};